<template>
  <div :class="`${LayoutType} ${Theme} d-flex`">
    <!-- ---------------------------------- -->
    <!--- Vertical Header part -->
    <!-- ---------------------------------- -->
    <VerticalSidebar />
    <aside
      class="conteudo-principal"
      :class="
        setHorizontalLayout == false
          ? 'horizontal-page-wrapper'
          : 'page-wrapper'
      "
    >
      <VerticalHeader v-if="setHorizontalLayout" />

      <!-- <HorizontalHeader v-if="setHorizontalLayout" /> -->
      <!-- <HorizontalSidebar v-if="setHorizontalLayout" /> -->
      <div
        class="min-height"
        :class="
          setHorizontalLayout == true
            ? 'container-fluid p-4'
            : 'container-fluid p-4'
        "
      >
        <h3 class="page-title" v-if="tituloPagina && rota">
          {{ tituloPagina }}
        </h3>
        <b-breadcrumb class="p-0" v-if="rota">
          <b-breadcrumb-item href="/" custom>
            <b-icon
              icon="house-fill"
              scale="1.25"
              shift-v="1.25"
              aria-hidden="true"
            ></b-icon>
          </b-breadcrumb-item>
          <b-breadcrumb-item
            v-for="breadcrumb in breadcrumbs"
            :key="breadcrumb.titulo"
            :active="!breadcrumb.to"
            ><router-link v-if="breadcrumb.to" :to="breadcrumb.to">
              {{ breadcrumb.titulo }}
            </router-link>
            <span v-if="!breadcrumb.to">{{ breadcrumb.titulo }}</span>
          </b-breadcrumb-item>
        </b-breadcrumb>
        <router-view />
      </div>
    </aside>
    <footer
      v-if="!menuMobile || !menuAberto"
      :class="!abrirMenu || !menuAberto ? 'footer-collapsed' : 'footer-expanded'"
      class="footer"
    >
      Versão: <strong>{{ VERSION }}</strong>
    </footer>
  </div>
</template>

<script>
import { VERSION } from "@/config/config";
import VerticalHeader from "./vertical-header/VerticalHeader";
import VerticalSidebar from "./vertical-sidebar/VerticalSidebar";
import { mapState, mapGetters } from "vuex";
export default {
  name: "FullLayout",
  data() {
    return {
      VERSION,
      menuMobile: false,
      isMobile: false
    };
  },
  components: {
    VerticalHeader,
    VerticalSidebar,
  },
  computed: {
    ...mapState(["LayoutType", "Theme", "setHorizontalLayout", "abrirMenu", "menuAberto"]),
    ...mapGetters(["breadcrumbs", "tituloPagina"]),
    currentRouteName() {
      return this.$route.name;
    },
    rota() {
      return this.$route.path !== "/dashboard";
    },
  },
  methods: {
    winWidth() {
      window.addEventListener('resize', this.handleResize);
      this.handleResize();
    },
    handleResize() {
      const w = window.innerWidth;

      if (w < 992  && !this.isMobile) {
        this.$store.commit("SET_LAYOUT_TYPE", "mobile-sidebar");
        this.menuMobile = true;
        this.isMobile = true;
      } else if (w >= 992 && this.isMobile){
        this.$store.commit("SET_LAYOUT_TYPE", "full-sidebar");
        this.$store.commit("SET_MENU_ABERTO", true);
        this.menuMobile = false;
        this.isMobile = false;
      }
    },
  },
  mounted() {
    this.winWidth();
    this.$store.dispatch("app/buscarEmpresas");
  },
  watch: {},
};
</script>

<style>
.conteudo-principal {
  margin-bottom: 40px;
}

.footer {
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  max-height: 30px;
  background-color: white;
  text-align: center;
  color: darkgrey;
  position: fixed;
  left: 0;
  right: 0;
  transition: all 0.1s ease-in-out;
}

.footer-expanded {
  width: calc(100% - 320px);
  left: 320px;
}

.footer-collapsed {
  width: 100%;
}

li.breadcrumb-item {
  padding: 2px 10px;
  border-radius: 6px;
  background: linear-gradient(45deg, #e5e5e5, #cbcbcb);
  font-size: 12px;
  color: #333 !important;
  margin-right: 15px;
  font-weight: 600;
}

li.breadcrumb-item a {
  color: #333 !important;
}

li.breadcrumb-item:before {
  display: none;
}

li.breadcrumb-item.active {
  color: #666 !important;
}

h3.page-title {
  text-transform: uppercase;
  font-size: 23px;
  font-weight: 900;
  color: #e9a957;
}

.breadcrumb {
  border-bottom: 1px solid #e5e5e5;
  padding-bottom: 10px !important;
  border-radius: 0;
}

li.breadcrumb-item:before {
  content: "/";
  display: inline-block;
  position: absolute;
  margin-left: -18px;
  color: #999 !important;
}

li.breadcrumb-item:nth-child(1):before {
  display: none;
}
</style>
